import React, { useState } from 'react'

import { useIsCompanyProfileModal } from '@/components/misc/CompanyProfile/hooks/useIsCompanyProfileModal'
import { useIsCompanyProfilePage } from '@/components/misc/CompanyProfile/hooks/useIsCompanyProfilePage'
import Map from '@/components/misc/CompanyProfile/tabs/OverviewTab/Map'
import SectionHeading from '@/components/misc/CompanyProfile/tabs/OverviewTab/SectionHeading'
import { CompanyProfileItem } from '@/types/responses/companies'

interface Props {
  companyProfile: CompanyProfileItem
}

const Locations: React.FC<Props> = ({ companyProfile }) => {
  const [hasValidMarkers, setHasValidMarkers] = useState(true) // Must start as true as calc logic is executed in nested component
  const isCompanyProfileModal = useIsCompanyProfileModal()
  const isCompanyProfilePage = useIsCompanyProfilePage()
  const { directory, company } = companyProfile
  const isTradingName = !!directory?.fca?.frnTradingNameId
  const postcodes =
    directory && directory.postcode && directory.county && !isTradingName
      ? [{ postcode: directory.postcode, name: directory.county }]
      : []

  if (company) {
    for (const address of company.addresses) {
      const listing = { postcode: address.postcode, name: address.city }
      postcodes.push(listing)
    }
  }

  const locations = postcodes
    .filter(
      (location, index, self) =>
        index === self.findIndex((t) => t.name === location.name),
    )
    .map((location) => location.name)

  if (!locations.length) {
    return null
  }

  const clientLocations = companyProfile.company?.clientLocations

  return (
    <section>
      {isCompanyProfilePage && hasValidMarkers && (
        <Map
          postcodes={postcodes}
          className="my-1 w-full"
          style={{ height: '400px' }}
          setHasValidMarkers={setHasValidMarkers}
        />
      )}

      <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
        {hasValidMarkers && (
          <div className="md:pr-6">
            <SectionHeading>Office locations</SectionHeading>
            <p className="mb-2">{locations.join(', ')}</p>

            {isCompanyProfileModal && (
              <Map
                postcodes={postcodes}
                className="w-full"
                style={{ height: '250px' }}
                setHasValidMarkers={setHasValidMarkers}
              />
            )}
          </div>
        )}

        {clientLocations && (
          <div>
            <SectionHeading>Client locations</SectionHeading>
            <p className="mb-4">{clientLocations}</p>
          </div>
        )}
      </div>
    </section>
  )
}

export default Locations
